import React, { useEffect, useState } from "react";
import "./create.css";
import axios from "../../../../axios";
import CreateQuestion from "../Create_Question/CreateQuestion";
import { useNavigate, useLocation } from "react-router-dom"; // 🔥 useLocation add kiya

function Create() {
  const navigate = useNavigate();
  const location = useLocation(); // 🔥 location hook

  // 🔥 selectedBox nikaalo (state se ya localStorage se)
  const selectedBox =
    location.state?.selectedBox ||
    localStorage.getItem("selectedBox") ||
    "auto-evaluate";

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const standardList = [];
  const sectionList = [];
  const subjectList = [];
  const [click, setClick] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);
  const [specialChar1, setSpecialChar1] = useState(false);
  const [nameOfAS, setName] = useState("");
  const [nameofDescription, setNameofDescription] = useState("");

  const [assessmentDetails, setAssessmentDetails] = useState({
    name: null,
    description: null,
    teacher_id: teacher_id,
    type_id: null,
    standard_id: null,
    section_id: null,
    subject_id: null,
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: null,
    questions: [],
  });
  const {
    standard_id,
    section_id,
    subject_id,
    name,
    description,
    type_id,
    total_duration,
  } = assessmentDetails;

  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
    assessmentTypes: null,
    subjects: null,
  });
  const { standards, sections, assessmentTypes, subjects } = dropdownLists;
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  useEffect(() => {
    const getAssessmentType = async () => {
      try {
        let res = await axios.get(
          `/api/v1/assessment/assessmentType/get/school/${school_id}`,
        );
        res &&
          setDropdownLists((prev) => ({
            ...prev,
            assessmentTypes: res.data.data,
          }));
      } catch (error) {
        console.log(error);
      }
    };
    if (CTRole_Information && CTRole_Information.length > 0) {
      CTRole_Information?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    if (CoRole_Information && CoRole_Information.length > 0) {
      CoRole_Information?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    if (general_role && general_role.length > 0) {
      general_role?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    getAssessmentType();
    standardList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, standards: standardList }));

    sectionList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, sections: sectionList }));

    // subjectList.length > 0 &&
    //   setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      let res = await axios.get(
        `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
      );
      res.data.data.subjects.map((obj) => arrSubject.push(obj));
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  useEffect(() => {
    (async () => {
      let subjects = [];
      if (
        ((CTRole_Information && CTRole_Information.length > 0) ||
          (CoRole_Information && CoRole_Information.length > 0)) &&
        assessmentDetails.standard_id !== null &&
        assessmentDetails.section_id !== null
      ) {
        subjects = await getSubjects(
          assessmentDetails.standard_id?.id,
          assessmentDetails.section_id?.id,
        ); //obj.subjects_id;
      }
      if (CTRole_Information && CTRole_Information.length > 0) {
        CTRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (CoRole_Information && CoRole_Information.length > 0) {
        CoRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (general_role && general_role.length > 0) {
        general_role?.forEach((obj) => {
          let subjects = obj.subjects_id;
          if (subjects.length > 0) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        });
      }

      subjectList.length > 0 &&
        setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentDetails.standard_id, assessmentDetails.section_id]);
  const navigateTo = localStorage.getItem("ActiveBtn");
  // const [nameEnable, setNameEnable] = useState(true);
  // const [descriptionEnable, setDescriptionEnable] = useState(true);
  return (
    <>
      {!click && (
        <div className="create_wrap w-100 h-100">
          <div
            className="mb-4"
            onClick={() => {
              navigate("/publishedAssessment");
            }}
          >
            <img src="/images/Back Arrow.svg" alt=""></img>
            <span className="published_hw_file_path1">
              &nbsp; Publish Assessment &nbsp;
            </span>
          </div>

          <div className="assessment_details d-flex flex-column">
            <div className="d-flex">
              <input
                className="assessment_input mb-3"
                style={{ minWidth: "25%" }}
                type="text"
                maxLength={50}
                value={nameOfAS}
                placeholder="Enter assessment name"
                // disabled={nameEnable}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/; // Regular expression to allow only letters, numbers, and spaces
                  if (regex.test(value) || value === "") {
                    setName(value);
                    setAssessmentDetails({
                      ...assessmentDetails,
                      name: value,
                    });
                    setSpecialChar(false);
                  } else {
                    // Handle error, e.g., display a message or prevent form submission
                    if (value !== "") {
                      setSpecialChar(true);
                    }
                  }
                }}
              />
              {/* hide the pencil icon */}
              {/* <img className="mb-1" style={{ width: "20px" }} src="/images/pencil_icon.svg" alt="" onClick={() => { setNameEnable(false) }} /> */}
            </div>
            {specialChar && (
              <p className="SpclStyle">*Special Character Not Allowed.</p>
            )}
            <div className="d-flex">
              <input
                className="assessment_input mb-3"
                style={{ minWidth: "50%" }}
                type="text"
                maxLength={250}
                value={nameofDescription}
                placeholder="Enter assessment description"
                // disabled={descriptionEnable}
                onChange={(e) => {
                  const values = e.target.value;
                  const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/; // Regular expression to allow only letters, numbers, and spaces
                  if (regex.test(values) || values === "") {
                    setNameofDescription(values);
                    setAssessmentDetails({
                      ...assessmentDetails,
                      description: values,
                    });
                    setSpecialChar1(false);
                  } else {
                    // Handle error, e.g., display a message or prevent form submission
                    if (values !== "") {
                      setSpecialChar1(true);
                    }
                  }
                }}
              />
              {/* hide the pencil icon */}
              {/* <img className="mb-1" style={{ width: "20px" }} src="/images/pencil_icon.svg" alt="" onClick={() => { setDescriptionEnable(false) }} /> */}
            </div>
            {specialChar1 && (
              <p className="SpclStyle">*Special Character Not Allowed.</p>
            )}
          </div>
          <div className="total_dropdown">
            <div className="create_dropdown1 p-0  col-12 my-custom-margin">
              <div className="d-flex gap-2 col-6 p-0">
                <select
                  className="form-select"
                  value={assessmentDetails?.standard_id?.id}
                  id={assessmentDetails?.standard_id?.name ? "bye" : "bello"}
                  onChange={(e) =>
                    setAssessmentDetails({
                      ...assessmentDetails,
                      standard_id: {
                        id: e.target.value,
                        name: e.target.options[
                          e.target.selectedIndex
                        ].getAttribute("name"),
                      },
                    })
                  }
                >
                  <option selected>Select class</option>
                  {standards?.length > 0 &&
                    standards?.map((standard, index) => (
                      <option
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </option>
                    ))}
                </select>

                <select
                  className="form-select"
                  value={assessmentDetails?.section_id?.id}
                  id={assessmentDetails?.section_id?.name ? "bye" : "bello"}
                  onChange={(e) =>
                    setAssessmentDetails({
                      ...assessmentDetails,
                      section_id: {
                        id: e.target.value,
                        name: e.target.options[
                          e.target.selectedIndex
                        ].getAttribute("name"),
                      },
                    })
                  }
                >
                  <option>Select section</option>
                  {standard_id &&
                    sections?.length > 0 &&
                    sections
                      ?.slice()
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((section, index) => (
                        <option
                          key={index}
                          value={section.id}
                          name={section.name}
                        >
                          {section.name}
                        </option>
                      ))}
                </select>
              </div>
              <select
                className="form-select ml-2 "
                value={assessmentDetails?.subject_id?.id}
                id={assessmentDetails?.subject_id?.name ? "bye" : "bello"}
                aria-label="Default select example"
                onChange={(e) =>
                  setAssessmentDetails({
                    ...assessmentDetails,
                    subject_id: {
                      id: e.target.value,
                      name: e.target.options[
                        e.target.selectedIndex
                      ].getAttribute("name"),
                    },
                  })
                }
              >
                <option>Select subject</option>
                {section_id &&
                  subjects?.length > 0 &&
                  subjects?.map((subject, index) => (
                    <option key={index} value={subject.id} name={subject.name}>
                      {subject.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="create_dropdown1 p-0  col-12 my-custom-margin">
              <div className="d-flex gap-2 col-6 p-0 ">
                <select
                  className="form-select jshjh"
                  value={assessmentDetails?.type_id}
                  id={
                    assessmentDetails?.type_id &&
                    assessmentDetails?.type_id !== "null"
                      ? "bye"
                      : "bello"
                  }
                  style={{ width: "95%" }}
                  onChange={(e) =>
                    setAssessmentDetails({
                      ...assessmentDetails,
                      type_id: e.target.value,
                    })
                  }
                >
                  <option selected value={"null"}>
                    {" "}
                    Select Assessment type
                  </option>
                  {assessmentTypes?.length > 0 &&
                    assessmentTypes?.map((type, index) => (
                      <option key={index} value={type?.id}>
                        {type?.name}
                      </option>
                    ))}
                </select>
                <input
                  className="form-control"
                  id={
                    assessmentDetails.total_duration > 0
                      ? "byeInput"
                      : "belloInput"
                  }
                  placeholder="Duration (In minutes)"
                  value={assessmentDetails.total_duration}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (/^\d*$/.test(value) || value === "") {
                      const maxValue = 1440;
                      if (value === "" || parseInt(value) <= maxValue) {
                        setAssessmentDetails({
                          ...assessmentDetails,
                          total_duration: value,
                        });
                      }
                    }
                  }}
                  style={{
                    width: "100%",
                    color:
                      assessmentDetails.total_duration > 0
                        ? "black"
                        : "#668598",
                  }}
                  type="number"
                  min="0"
                  max="1440"
                  maxLength={4}
                />
              </div>
              <input
                className="form-control ml-2"
                id={
                  assessmentDetails.tags.length > 0 ? "byeInput" : "belloInput"
                }
                placeholder="⊕ Add Tag"
                style={{
                  color:
                    assessmentDetails.tags.length > 0 ? "black" : "#668598",
                }}
                onBlur={(e) =>
                  setAssessmentDetails({
                    ...assessmentDetails,
                    tags: e.target.value.split(","),
                  })
                }
              ></input>
            </div>
            {/* </div> */}
          </div>

          <button
            disabled={
              !standard_id ||
              !subject_id ||
              !section_id ||
              !type_id ||
              !name ||
              !description ||
              !total_duration
            }
            className="btn Next_button"
            onClick={() => setClick(!click)}
          >
            Next
          </button>
        </div>
      )}
      {click && (
        <CreateQuestion
          setClickFromCreate={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          selectedBox={selectedBox} // 🔥 YEH PASS KARO
        />
      )}
    </>
  );
}

export default Create;
